<template>
  <aside class="app-sidebar">
    <div class="app-sidebar__user text-center">
      <img v-if="account" class="mb-3" :src="`data:image/png;base64,${account.image}`" alt="User Image" width="100">
      <img v-else class="mb-3" src="@/assets/user.png" alt="User Image" width="120">
      <div v-if="isAuthenticated">
        <p class="app-sidebar__user-name">{{ user.name }}</p>
        <p class="app-sidebar__user-designation">{{ account.job_position }}</p>
        <p class="app-sidebar__user-designation"><span v-if="account.department">{{ account.department.name }}</span>
        </p>
      </div>
    </div>
    <ul class="app-menu">
      <!-- Menu items -->
      <li>
        <router-link class="app-menu__item" to="/viewer">
          <i class="app-menu__icon bi bi-speedometer"></i>
          <span class="app-menu__label">Dashboard</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/">
          <i class="app-menu__icon bi bi-speedometer"></i>
          <span class="app-menu__label">หน้าหลัก</span>
        </router-link>
      </li>
      <!-- <li class="treeview">
          <router-link class="app-menu__item" to="#" data-toggle="treeview">
            <i class="app-menu__icon bi bi-ui-checks"></i>
            <span class="app-menu__label">Forms</span>
            <i class="treeview-indicator bi bi-chevron-right"></i>
          </router-link>
          <ul class="treeview-menu">
            <li><router-link class="treeview-item" to="/form-components"><i class="icon bi bi-circle-fill"></i> Form Components</router-link></li>
            <li><router-link class="treeview-item" to="/form-samples"><i class="icon bi bi-circle-fill"></i> Form Samples</router-link></li>
          </ul>
        </li>
        <li>
          <router-link class="app-menu__item" to="/docs">
            <i class="app-menu__icon bi bi-list-ol"></i>
            <span class="app-menu__label">Docs</span>
          </router-link>
        </li> -->
      <li>
        <router-link class="app-menu__item" to="/checklists">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">รายการตรวจเช็ค</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/groups">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">หน่วยงาน</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/restrooms">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">ห้องน้ำ</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link class="app-menu__item" to="/cleaning-items">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">รายการตรวจห้องน้ำ</span>
        </router-link>
      </li> -->
      <li>
        <router-link class="app-menu__item" to="/fire-extinguisher">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">ถังดับเพลิง</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link class="app-menu__item" to="/fire-extinguisher-items">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">รายการตรวจถังดับเพลิง</span>
        </router-link>
      </li> -->
      <li>
        <router-link class="app-menu__item" to="/medicine-cabinets">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">ตู้แช่ยาและเวชภัณฑ์</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/rooms">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">ห้องควบคุมอุณหภูมิ</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/gas-pressure-value">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">ค่าแรงดันก๊าซ</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/defibrillator">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">เครื่องกระตุกหัวใจ (Defibrillator)</span>
        </router-link>
      </li>
      <li v-if="userRole === 'admin'">
        <router-link class="app-menu__item" to="/settings">
          <i class="app-menu__icon bi bi-gear"></i>
          <span class="app-menu__label">ตั้งค่าระบบ</span>
        </router-link>
      </li>
      <!-- <li>
        <router-link class="app-menu__item" to="/medicine-cabinets">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">ตรวจเช็ค/ตู้ยาและเวชภัณฑ์</span>
        </router-link>
      </li> -->
      <!-- <li>
        <router-link class="app-menu__item" to="/users">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">Users</span>
        </router-link>
      </li>
      <li>
        <router-link class="app-menu__item" to="/users">
          <i class="app-menu__icon bi bi-list-ol"></i>
          <span class="app-menu__label">Users</span>
        </router-link>
      </li> -->
    </ul>
  </aside>
</template>

<script>
import usersService from '@/services/users-service';
import { mapState } from 'vuex';

export default {
  name: 'Sidebar',
  data() {
    return {
      account: {}
    }
  },
  methods: {
    async getUser(id) {
      try {
        const res = await usersService.get(id)
        this.account = res.data.account
      } catch (error) {
        alert(error)
        console.log(error);

        localStorage.removeItem('vuex')
      }
    },
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    userRole() {
      return this.$store.getters.userRole;
    },
    ...mapState(['app', 'user'])
  },
  created() {
    this.getUser(this.user.id)
  },
};
</script>

<style scoped>
/* Add your styles here */
.app-sidebar__user {
  display: block;
  margin-bottom: 0px;
}
</style>